<template>
  <button 
    @click.stop="toggleFavorite"
    class="favorite-button"
    :class="{ 'is-favorited': isFavorited }"
    :aria-label="isFavorited ? 'Remove from favorites' : 'Add to favorites'"
    :title="isFavorited ? 'Remove from favorites' : 'Add to favorites'"
  >
    <HeartIcon v-if="!isFavorited" class="h-6 w-6 text-muted-foreground hover:text-primary transition-colors" />
    <HeartIconSolid v-else class="h-6 w-6 text-primary transition-colors" />
  </button>
</template>

<script setup lang="ts">
import { HeartIcon } from '@heroicons/vue/24/outline'
import { HeartIcon as HeartIconSolid } from '@heroicons/vue/24/solid'
import { useFavoritesStore } from '~/stores/favorites'

const props = defineProps({
  vehicleId: {
    type: String,
    required: true
  }
})

const favoritesStore = useFavoritesStore()

const isFavorited = computed(() => {
  return favoritesStore.isFavorite(props.vehicleId);
})

const toggleFavorite = () => {
  favoritesStore.toggleFavorite(props.vehicleId);
}
</script>

<style scoped>
.favorite-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 9999px;
  background-color: hsl(var(--background) / 0.8);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.favorite-button:hover {
  transform: scale(1.05);
  background-color: hsl(var(--background) / 0.9);
}

.favorite-button.is-favorited:hover .heart-icon {
  color: hsl(var(--destructive));
}
</style>
